import { asyncTimeout } from 'utils/asyncTimeout';
import { SERVICES_MOCK_DELAY } from 'utils/constants';
import { sportApplicationsStoreMock } from 'services/mock/utils/sportApplicationsModel';

export const getNewSportApplicationsCount = async () => {
  await asyncTimeout(SERVICES_MOCK_DELAY);

  return sportApplicationsStoreMock.getAllNewApplications().length;
};
